import React from 'react';
import { useTheme } from '@material-ui/core';

const CompletedImg = () => {
  const theme = useTheme();

  return (
    <svg
      width="92"
      height="92"
      viewBox="0 0 92 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <circle
          fill={theme.palette.custom.feedback.positive}
          opacity="0.08"
          cx="45"
          cy="46"
          r="46"
        />
        <path
          fill={theme.palette.custom.feedback.positive}
          d="M22.6507 55.0856C25.5642 57.9041 28.4671 60.642 31.3806 63.4605C33.0761 65.1257 35.0942 66.7486 37.7354 66.2382C40.1452 65.8402 41.6385 64.0852 43.3248 62.5511C49.1761 57.1064 55.0168 51.5809 60.8682 46.1361C64.2303 42.9872 67.5117 39.8489 70.8844 36.7807C72.42 35.3484 73.1621 32.8713 71.6174 31.1042C70.2658 29.5581 67.5466 28.8477 65.9409 30.3713C60.4613 35.5211 55.0517 40.5797 49.5721 45.7296C46.7919 48.3098 44.0924 50.8794 41.3123 53.4597C39.9275 54.7901 38.5321 56.0399 37.228 57.3597C36.8563 57.6547 36.5759 58.0197 36.2043 58.3146C36.0535 58.4164 35.9027 58.5183 35.7519 58.6201C35.4609 58.9044 35.822 58.5288 35.9027 58.5183C36.3762 58.3741 37.0216 58.2895 37.5268 58.3874C37.6988 58.4469 37.9831 58.7379 37.7794 58.4363C37.4845 58.0647 37.0388 57.7949 36.7545 57.5039C33.7391 54.5346 30.6431 51.5758 27.6384 48.6872C26.1254 47.1622 23.0914 47.8062 21.9103 49.4382C20.5188 51.3439 21.0465 53.4905 22.6507 55.0856Z"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect
            width="92"
            height="92"
            fill={theme.palette.custom.background.area}
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CompletedImg;
